import { getLinkedAccountsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/multiaccountKeys.js';
import { getLinkedAccounts } from '#pplx/frontend/auth/queries/getLinkedAccounts.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
export function useLinkedAccountsQuery({ reason, }) {
    return useQuery({
        queryKey: getLinkedAccountsQueryKey(),
        queryFn: async () => getLinkedAccounts({ reason }),
    });
}
//# sourceMappingURL=useLinkedAccountsQuery.js.map